import styled from 'styled-components';

export const ProfileContainer = styled.div`
  background-color: ${({ theme }) => theme.colours.white};
  border-radius: ${({ theme }) => theme.pxToRem(5)};
  display: flex;
  padding: 0;
`;

export const MessageContainer = styled.div`
  color: ${({ theme }) => theme.colours.black};
  padding: ${({ theme }) => theme.pxToRem(30)};
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
